"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ListBoxSection = void 0;
var react_1 = __importStar(require("react"));
var uuid_1 = require("uuid");
var a11y_1 = require("@kaizen/a11y");
var ListBoxSection_module_scss_1 = __importDefault(require("./ListBoxSection.module.scss"));
var ListBoxSection = function (_a) {
    var items = _a.items, children = _a.children, sectionName = _a.sectionName, restProps = __rest(_a, ["items", "children", "sectionName"]);
    var listSectionId = (0, react_1.useState)((0, uuid_1.v4)())[0];
    var hasSectionHeader = "sectionHeader" in restProps;
    return (react_1["default"].createElement("li", { role: "presentation" },
        react_1["default"].createElement("ul", { className: ListBoxSection_module_scss_1["default"].listBoxSection, "aria-label": !hasSectionHeader ? sectionName : undefined, "aria-labelledby": hasSectionHeader ? listSectionId : undefined, role: "group" },
            hasSectionHeader && (react_1["default"].createElement("li", { className: ListBoxSection_module_scss_1["default"].listBoxSectionHeader, id: listSectionId, role: "presentation" },
                sectionName && react_1["default"].createElement(a11y_1.VisuallyHidden, null,
                    sectionName,
                    ". "),
                restProps.sectionHeader)),
            Array.from(items).map(function (node) { return node != undefined && children(node); }))));
};
exports.ListBoxSection = ListBoxSection;
exports.ListBoxSection.displayName = "ListBoxSection";
//# sourceMappingURL=ListBoxSection.js.map